import { Reveal } from "./motion";
import { IMAGES } from "@/lib/product";
import { Brain, Activity, ShieldPlus, Coffee } from "lucide-react";

const ITEMS = [
  {
    icon: Brain,
    name: "LION'S MANE",
    dose: "1000mg",
    benefit: "Neurotropic focus & mental clarity. The lock-in molecule.",
  },
  {
    icon: Activity,
    name: "CORDYCEPS",
    dose: "750mg",
    benefit: "Clean, oxygen-driven endurance. Energy that lasts hours.",
  },
  {
    icon: ShieldPlus,
    name: "CHAGA",
    dose: "500mg",
    benefit: "Antioxidant defense. Buffers the caffeine stress response.",
  },
  {
    icon: Coffee,
    name: "ARABICA",
    dose: "Medium-Dark",
    benefit: "Single-origin, smooth roast. Tastes like real coffee. Because it is.",
  },
];

export const Ingredients = () => {
  return (
    <section
      id="ingredients"
      data-testid="ingredients-section"
      className="border-y border-zinc-800 bg-surface-100"
    >
      <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.3em] text-blaze">
                The Formula
              </p>
              <h2 className="font-display text-5xl uppercase leading-[0.9] tracking-tight sm:text-6xl">
                Four inputs.
                <br />
                <span className="text-zinc-600">One</span> upgrade.
              </h2>
              <p className="mt-5 max-w-sm text-base leading-relaxed text-zinc-400">
                No fillers. No fairy dust. Just clinically-dosed functional
                mushrooms blended into premium arabica.
              </p>
              <div className="mt-8 overflow-hidden border border-zinc-800">
                <img
                  src={IMAGES.mushroom}
                  alt="Functional mushrooms"
                  className="h-56 w-full object-cover"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {ITEMS.map((it, i) => (
                <Reveal key={it.name} delay={i * 0.08}>
                  <div
                    data-testid={`ingredient-${it.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
                    className="group h-full border border-zinc-800 bg-[#09090B] p-7 transition-colors duration-300 hover:border-blaze"
                  >
                    <div className="flex items-start justify-between">
                      <it.icon className="h-8 w-8 text-blaze" strokeWidth={1.5} />
                      <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                        {it.dose}
                      </span>
                    </div>
                    <h3 className="mt-8 font-display text-3xl uppercase tracking-tight">
                      {it.name}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-zinc-400">
                      {it.benefit}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
